// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"profile-menu_dropdown__jRDkz","avatar":"profile-menu_avatar__fmDEk","menuIcon":"profile-menu_menuIcon__3RBGi"};